import React, { useState } from "react";
import PropTypes from "prop-types";
import { withLocalizeStrings } from "../languages/Localize";
import { confirmPayment as confirmPaymentApi, getApplicationData, getUuid, postQuestionsAndComment } from "./application.service";
import { useHistory, withRouter } from "react-router-dom";
import { appDataMockUp } from "./appData.mockup";
import { getForumFullAgenda } from "../util/util";
import moment from "moment";
import routes from "../config/routes";

const defaultState = {
    appData: {
        ...appDataMockUp
    },
    loading: null,
    started: null,
    uuid: null,
    forumFullAgenda: null,
    position: null
};

const defaultActions = {
    setLoading: _payload => {},
    setStarted: _payload => {},
    setPosition: _payload => {},
    sendQuestionsAndComment: (_payload, _id) => {},
    confirmPayment: payload => {}
};

export const ApplicationContext = React.createContext({
    ...defaultState,
    ...defaultActions
});
export const ApplicationConsumer = ApplicationContext.Consumer;

const ApplicationProvider = props => {
    const [appData, setAppData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [started, setStarted] = useState(false);
    const [forumFullAgenda, setForumFullAgenda] = useState(null);
    const [uuid, setUuid] = useState(null);
    const [position, setPositionBase] = useState({ id: 0, top: 0 });
    const history = useHistory();

    const setPosition = field => setPositionBase(prevState => ({ ...prevState, ...field }));

    const fetchAppData = uuid => {
        setLoading(true);
        getApplicationData(uuid).then(({ data }) => {
            setLoading(false);
            setAppData({ ...data });
            if (moment().isAfter(data.forumStartTime)) {
                setStarted(true);
            }
            setForumFullAgenda(getForumFullAgenda(data));
        });
    };

    const confirmPayment = payload => {
        confirmPaymentApi(payload)
            .then(response => {
                localStorage.setItem("qrCode", response.data?.accessCode);
                history.push(routes.SUCCESSFUL_EPAYMENT);
            })
            .catch(err => {
                history.push(routes.FAIL_EPAYMENT);
                console.log(err);
            });
    };

    const sendQuestionsAndComment = (payload, id) => {
        postQuestionsAndComment(payload, id).then(() => {
            fetchAppData(uuid);
        });
    };

    React.useEffect(() => {
        const uuid = getUuid();
        fetchAppData(uuid);
        setUuid(uuid);
    }, []);

    const state = {
        appData,
        loading,
        uuid,
        started,
        position,
        setPosition,
        forumFullAgenda,
        setStarted,
        setLoading,
        sendQuestionsAndComment,
        confirmPayment
    };

    return (
        <ApplicationContext.Provider value={state}>
            {appData === null || forumFullAgenda === null ? null : props.children}
        </ApplicationContext.Provider>
    );
};

ApplicationProvider.propTypes = {
    children: PropTypes.node.isRequired
};
export const useApplicationStateValue = () => React.useContext(ApplicationContext);

export default withRouter(withLocalizeStrings(ApplicationProvider));
